import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getLicenseTypes } from 'api/License';

export const useGetLicenseTypes = ({ params = {}, options = {}, dependencies = [] } = {}) => {
  const navigate = useNavigate();
  return useQuery(['license-types', ...dependencies], () => getLicenseTypes(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...options
  });
};
